var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    viewBox: "0 0 20.4944 20.4944",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2471 0.5C15.6303 0.5 19.9941 4.8639 19.9941 10.2471C19.9941 15.6303 15.6303 19.9941 10.2471 19.9941C4.8639 19.9941 0.5 15.6303 0.5 10.2471C0.50007 4.86394 4.86394 0.50007 10.2471 0.5Z",
    fill: "white",
    stroke: "#119ED9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox_unchecked.c46d0231bb50c81f3852cf7347f8f937.svg";
export { ForwardRef as ReactComponent };